export default [
    {
        path: "/pages",
        redirect: "/pages/404",
        name: "Pages",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "404",
                name: "Page404",
                component: () => import("@/views/pages/Page404"),
                meta: {
                    title: "Oop"
                },
            },
            {
                path: "500",
                name: "Page500",
                component: () => import("@/views/pages/Page500"),
            },
            {
                path: "login",
                name: "Login",
                component: () => import("@/views/pages/Login"),
                meta: {
                    title: "Đăng nhập"
                },
            },
            {
                path: "register",
                name: "Register",
                component: () => import("@/views/pages/Register"),
            },
            {
                path: "/pages/not-authorized",
                name: "Not Authorized",
                component: () => import("@/views/pages/NotAuthorized"),
                meta: {
                    title: "Không có quyền truy cập"
                },
            },
        ],
    }
]